import { useTheme } from '@mui/material/styles';

export const DefinitionCardStyles = () => {
    const theme = useTheme();
    return {
        minWidth: {
            sm:"525px",
            md:"550px"
        },
        height: "auto",
        marginTop: "10px",
        "& .card__row-color:nth-of-type(2n+1)": {
            background: theme.palette.purpleCold.light,
        },
        "& .MuiCardContent": {
            padding: "4px",
        },
        "& .MuiCardContent-root:last-child": {
            paddingBottom: "0",
        }, 
        "& .MuiTableCell-root": {
            fontSize: "0.8rem",
        }
    }
}